import { createUseBottomSheetModal } from '@banhala/ui-kit';
import {
  GoodsParamsContext,
  type GoodsParamsLogging,
} from '../../context/GoodsParamsContext';
import {
  PostGoodsActionBottomSheetContent,
  type PostGoodsActionBottomSheetParams,
} from './PostGoodsActionBottomSheet';

type WishlistPostGoodsActionParam = PostGoodsActionBottomSheetParams & {
  goodsId: number;
  logging: GoodsParamsLogging;
};

/**
 * 찜탭(EXP1768 C군)처럼 GoodsDetail route 밖에서 장바구니 담기 후 연관추천 시트를
 * 단독으로 띄울 때 사용. goodsId/logging 을 GoodsParamsContext 로 주입해, modal portal
 * (NavigationContainer 밖) 안의 useGoodsSno/로깅 훅이 route 없이도 동작하게 한다.
 */
export const useWishlistPostGoodsActionBottomSheet = createUseBottomSheetModal<
  void,
  WishlistPostGoodsActionParam
>(
  ({ param, confirm }) => (
    <GoodsParamsContext.Provider
      value={{ goodsId: param.goodsId, logging: param.logging }}
    >
      <PostGoodsActionBottomSheetContent param={param} confirm={confirm} />
    </GoodsParamsContext.Provider>
  ),
  {
    cancelOnBackButtonPress: false,
  },
);
